import React from 'react';
import { CardTabs } from '@ui-library/tabs';
import { useCloudSourceInfo } from '@stores/cloudSourcesInfo/cloudSourcesInfo';
import CloudSourceStatus from './cloudSourceStatusTab';
import cloudSourceRunHistoryTab from './cloudSourceRunHistoryTab';
import CloudSourceReports from './cloudSourceReports';

type Props = {
  isAdmin: boolean;
};

const CloudSourceDetails = ({ isAdmin }: Props) => {
  const { reportsViewEnabled } = useCloudSourceInfo();
  if (reportsViewEnabled) {
    return CloudSourceReports(isAdmin);
  }
  return (
    <CardTabs
      tabs={[
        { title: 'Status', component: () => <CloudSourceStatus isAdmin={isAdmin} /> },
        { title: 'History', component: cloudSourceRunHistoryTab },
      ]}
    />
  );
};

export default CloudSourceDetails;
